module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "https://medias.intelisoft.ca/intelisoft_dashboard.png",
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93496c88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashHeader.vue
// module id = 1344
// module chunks = 1